import type { FirebaseOptions } from "@firebase/app";

export const firebaseConfig: FirebaseOptions = {
  projectId: process.env.FIREBASE_PROJECT_ID,
  apiKey: process.env.FIREBASE_WEB_API_KEY,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
};
